import { IntegrationType } from "./integrationTypes.enum";

export const IntegrationsWithUserManagement = {
  [IntegrationType.GSUITE]: IntegrationType.GSUITE,
  [IntegrationType.DARWINBOX]: IntegrationType.DARWINBOX,
  [IntegrationType.KEKA]: IntegrationType.KEKA,
  [IntegrationType.ZOHOPEOPLE]: IntegrationType.ZOHOPEOPLE,
};
